import { useCallback, useState } from 'react';

import { Criticality } from '@/features/common/components/CriticalityFilter';
import { CommonSortBy, useCommonQueryParams } from '@/features/common/hooks/useCommonQueryParams';
import { GetBrakesRequestParams } from '@/services/vehicleDiagnosticsApi';

const BRAKE_ALLOWED_SORT_BY = ['axle', 'side', 'value'] as const;
type BrakeSorting = (typeof BRAKE_ALLOWED_SORT_BY)[number];
export type BrakeSortBy = CommonSortBy | BrakeSorting;

export interface RangeValue {
    from?: number;
    to?: number;
}

export const useBrakesQueryParams = ({
    sortBy,
    sortDirection,
    pageNumber,
    pageSize,
    assetIds,
    workshopIds,
    accountIds,
    min = 0,
    max = 100,
}: Partial<GetBrakesRequestParams>) => {
    const commonQueryParams = useCommonQueryParams<BrakeSortBy>({
        sortBy,
        sortDirection,
        pageNumber,
        pageSize,
        assetIds,
        workshopIds,
        accountIds,
    });
    const [minState, setMinState] = useState<number>(min);
    const [maxState, setMaxState] = useState<number>(max);
    const [criticalityStatus, setCriticalityStatus] = useState<Criticality[]>([]);
    const setRange = useCallback(
        ({ from, to }: RangeValue) => {
            setMinState(from ?? min);
            setMaxState(to ?? max);
        },
        [min, max],
    );

    return {
        min: minState,
        setMin: setMinState,
        max: maxState,
        setMax: setMaxState,
        setRange,
        criticalityStatus,
        setCriticalityStatus,
        ...commonQueryParams,
    };
};
